import React, { useEffect } from 'react'
import Layout from '../../components/common/pageLayout'
import './planApproval.css'
import CreateForm from '../../components/PlanApproval/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_create_planApproval } from '../../actions/v3/planApproval'
import { toast } from 'react-toastify'

const Index = (props) => {
    const location = useLocation();
    const { projectId, projectName } = location.state;

    console.log(projectName)
    const onSubmit = (model) => {
        v3_create_planApproval(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.planApprovalProject.url,
                    state: {
                        projectName,
                        projectId
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title='Plan Approval'>
            <CreateForm
                onSubmit={onSubmit}
                projectId={projectId}
            />
        </Layout>
    )
}

export default Index